import Vue from 'vue'
import http from '@/services/http.service'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.dialog) this.$role = options.role
    else if (options.parent && options.parent.$role)
      this.$role = options.parent.$role
  },
})

export default {
  getRoles() {
    return http.get('/roles').then(r => r.data)
  },
}
